// extracted by mini-css-extract-plugin
module.exports = {"textContentContainer":"ParentMenu_textContentContainer__2nwwN"};